<h1 mat-dialog-title class="p-2 text-center">Ajout d'une zone à comparer</h1>
<div mat-dialog-content class="p-3">

    <div class="row">
        <mat-form-field class="col">
            <mat-label>Différentiel de pression (Pa)</mat-label>
            <input matInput type="text" inputmode="numeric" (keydown)="checkCharacters($event)" [(ngModel)]="diffPression" placeholder="Différentiel de pression" required>
            @if (!validCharacters()) {
                <span class="error">
                    Saisir un nombre
                </span>
                }
        </mat-form-field>
    </div>

    <div class="row">
        <mat-form-field class="col">
            <mat-label>Nom</mat-label>
            <input matInput [(ngModel)]="Model.Name" placeholder="ex. au couloir, au SAS, ..." required>
        </mat-form-field>
    </div>

    <div class="row mt-3 g-0">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
            Annuler
        </button>
        <button appPreventDoubleClick class="col ms-1" color="accent" mat-raised-button (throttledClick)="onConfirm()" [disabled]="!canSave()">
            Valider
        </button>
    </div>
</div>